import type { EffectivePermissionGroup, PermissionUser } from '../types/permissionsList.types';

interface EffectivePermissionsBlockProps {
  users: PermissionUser[];
  selectedUser: PermissionUser | null;
  selectedUserId: string;
  groups: EffectivePermissionGroup[];
  onUserChange: (userId: string) => void;
}

export function EffectivePermissionsBlock({ users, selectedUser, selectedUserId, groups, onUserChange }: EffectivePermissionsBlockProps) {
  return (
    <section className="min-w-0 overflow-hidden rounded-md border border-slate-100 bg-white p-3 shadow-sm">
      <div className="min-w-0 space-y-2 text-sm">
        <div className="flex min-w-0 flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div className="min-w-0">
            <h2 className="truncate font-medium text-slate-900">Quyền hiệu lực theo người dùng</h2>
            <p className="line-clamp-2 text-slate-500">Xem quyền thực tế sau khi áp dụng vai trò hiện tại.</p>
          </div>
          <select
            value={selectedUserId || selectedUser?.id || ''}
            onChange={(event) => onUserChange(event.target.value)}
            className="h-10 min-w-0 rounded-md border border-slate-200 bg-white px-3 text-sm text-slate-700 outline-none lg:w-80"
          >
            {users.map((user) => (
              <option key={user.id} value={user.id}>{user.fullName} - {user.roleCode}</option>
            ))}
          </select>
        </div>

        {selectedUser ? (
          <div className="grid gap-3 lg:grid-cols-[240px_1fr]">
            <div className="min-w-0 rounded-md bg-slate-50 p-3">
              <div className="space-y-2 text-sm">
                <p className="truncate font-medium text-slate-900">{selectedUser.fullName}</p>
                <p className="truncate text-slate-500">{selectedUser.email || 'Chưa có email'}</p>
                <p className="truncate text-slate-500">Vai trò: {selectedUser.roleCode}</p>
                <p className="truncate text-slate-500">Chức danh: {selectedUser.jobTitle || 'Chưa cập nhật'}</p>
              </div>
            </div>
            <div className="min-w-0 overflow-hidden rounded-md border border-slate-100">
              <div className="max-h-72 overflow-auto p-3">
                {groups.length ? (
                  <div className="space-y-3">
                    {groups.map((group) => (
                      <div key={group.moduleName} className="min-w-0 space-y-2">
                        <p className="truncate font-medium text-slate-800">{group.moduleName}</p>
                        <div className="flex min-w-0 flex-wrap gap-2">
                          {group.permissions.map((permission) => (
                            <span key={permission.key} className="max-w-full truncate rounded-md border border-emerald-100 bg-emerald-50 px-2 py-1 text-sm font-semibold text-emerald-700">
                              {permission.label} ({permission.roleNames.join(', ')})
                            </span>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-slate-400">Người dùng này chưa có quyền hiệu lực từ vai trò hiện tại.</p>
                )}
              </div>
            </div>
          </div>
        ) : (
          <p className="rounded-md bg-slate-50 p-3 text-sm text-slate-500">Chưa có người dùng để kiểm tra quyền hiệu lực.</p>
        )}
      </div>
    </section>
  );
}
